@if (isFamily) {
  <span class="family-tag" data-testid="family-tag">{{ familyLabel }}</span>
  @if (isPrimary) {
    <span class="family-tag" data-testid="family-primary-tag">{{ primaryLabel }}</span>
  }
}
